<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				delCells:[]
			};
		},
		created() {},
		methods: {
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			inputblur(e){
			this.$emit("inputblur",e)
			},
			fordelete(index){
				if(this.tableData.length<3){
					return false
				}
				if(this.$notemptyandnull(this.tableData[index]['zzs_7_x_1'].id)){
					this.delCells.push(JSON.parse(JSON.stringify(this.tableData[index])) )
				}
				this.tableData.splice(index,1)
				this.$emit('delCellsCode',this.delCells)
			},
			foraddhang() {
				let endobj=this.tableData[this.tableData.length-1]
				this.tableData.pop()
				this.tableData.push({
					zzs_7_x_1: {
						cellCode: "zzs_7_"+(parseFloat(this.tableData.length)+1)+"_1",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					zzs_7_x_2: {
						cellCode: "zzs_7_"+(parseFloat(this.tableData.length)+1)+"_2",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					zzs_7_x_3: {
						cellCode: "zzs_7_"+(parseFloat(this.tableData.length)+1)+"_3",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					zzs_7_x_4: {
						cellCode: "zzs_7_"+(parseFloat(this.tableData.length)+1)+"_4",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					zzs_7_x_5: {
						cellCode: "zzs_7_"+(parseFloat(this.tableData.length)+1)+"_5",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					zzs_7_x_6: {
						cellCode: "zzs_7_"+(parseFloat(this.tableData.length)+1)+"_6",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					}
				})
				this.tableData.push(
				endobj
				)
			}
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
